import request from '@/utils/request'
import { FollowAlarmResult } from '@/typings/api/analysis'

/**
 * ************************************** 分析 **************************************
 */
// 客户异动列表
export function followAlarmGet(data: any) {
  return request.post<FollowAlarmResult>('/ofbu/api/customer/alarm/page/list', data)
}
// 跟进记录客户异动列表
export function followAlarmListGet(data: any) {
  return request.post<FollowAlarmResult>('/ofbu/api/customer/alarm/list', data)
}
